import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";

import toast from "react-hot-toast";
import { base_url } from "./AgentWhitelist";

// Hoist RechargeForm outside to prevent recreation on every render
const RechargeForm = ({ type, stake, setStake, handleChange, handleProofChange, proofPreview, bank, formData, handleSubmit }) => (
  <form
    className="card shadow mt-4 w-100 w-md-75 w-lg-50 p-4"
    onSubmit={(e) => handleSubmit(e, type)}
  >
    <h4 className="mb-3">
      {type === "bank" && "Bank Payment"}
      {type === "qr" && "QR Code Payment"}
      {type === "upi" && "UPI Payment"}
    </h4>

    {/* Bank fields */}
    {type === "bank" &&
      (() => {
        const bankDetails = getBankDetails(stake, bank);
        return (
          <div className="row">
            <div className="mb-3 col-lg-3 col-md-6 col-12">
              <label className="form-label fw-bold">Holder Name</label>
              <input type="text" className="form-control" value={bankDetails.holder_name || ""} readOnly />
            </div>
            <div className="mb-3 col-lg-3 col-md-6 col-12">
              <label className="form-label fw-bold">Bank Name</label>
              <input type="text" className="form-control" value={bankDetails.bank_name || ""} readOnly />
            </div>
            <div className="mb-3 col-lg-3 col-md-6 col-12">
              <label className="form-label fw-bold">Account Number</label>
              <input type="text" className="form-control" value={bankDetails.account_number || ""} readOnly />
            </div>
            <div className="mb-3 col-lg-3 col-md-6 col-12">
              <label className="form-label fw-bold">IFSC Code</label>
              <input type="text" className="form-control" value={bankDetails.ifsc || ""} readOnly />
            </div>
          </div>
        );
      })()}

    {/* UPI */}
    {type === "upi" &&
      (() => {
        const bankDetails = getbankUpi(stake, bank);
        return (
          <div className="mb-3">
            <label className="form-label">UPI ID</label>
            <input type="text" value={bankDetails?.upiId || ""} className="form-control" readOnly />
          </div>
        );
      })()}

    {/* QR */}
    {type === "qr" && bank && (
      <div className="mb-3">
        <div className="border rounded p-3 bg-light shadow-sm text-center" style={{ maxWidth: "160px" }}>
          <img
            src={`${base_url}/payment/${bank?.qr_code_image}`}
            alt="QR Code"
            className="img-fluid"
            style={{ height: "150px", objectFit: "contain" }}
          />
          <p className="mt-2 mb-0 fw-bold text-secondary">Scan to Pay</p>
        </div>
      </div>
    )}


    {type === "contact" && (
      <div className="d-flex flex-wrap align-items-center justify-content-between p-3 bg-light rounded shadow-sm w-100">
        <div className="d-flex flex-wrap">
          <i className="fa fa-phone text-primary me-2" style={{ fontSize: '1.5em' }}></i>
          <span className="me-3 text-dark fw-bold" style={{ fontSize: '1.2em' }}>Contact:</span> <span>{stake}</span>
        </div>
        <a
          href={`https://wa.me/91${stake}`}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-success btn-sm rounded-pill"
          style={{ padding: '6px 12px', fontWeight: 'bold', transition: 'transform 0.2s' }}
          onMouseOver={e => (e.target.style.transform = 'scale(1.1)')}
          onMouseOut={e => (e.target.style.transform = 'scale(1)')}
        >
          <i className="fa fa-whatsapp me-1"></i> Chat
        </a>
      </div>
    )}




    {/* Amount & UTR */}
    { type!=='contact' &&(<>
      <div className="row my-3">
      <div className="mb-3 col-lg-6 col-12 d-flex flex-column">
        <label className="form-label">Amount</label>
        <input
          type="number"
          className="form-control"
          name="stake"
          value={stake}
          onChange={(e) => {setStake(Number(e.target.value)); handleChange(e)}}
          placeholder="Enter recharge amount"
        />
      </div>
      <div className="mb-3 col-lg-6 col-12 d-flex flex-column">
        <label className="form-label">UTR Number</label>
        <input
          type="text"
          name="utr"
          className="form-control"
          maxLength={16}
          value={formData.utr}
          onChange={handleChange}
          placeholder="Enter transaction reference"
        />
      </div>
    </div>

    {/* Quick select */}
    <div className="my-3">
      <ul className="d-flex flex-wrap justify-content-around gap-3 list-unstyled">
        {[5000, 10000, 15000, 25000, 50000, 75000, 100000, 150000, 200000].map((amt) => (
          <li
            key={amt}
            className={`border px-4 p-1 rounded ${stake === amt ? "bg-success text-white" : "border-primary"}`}
            onClick={() => setStake(amt)}
            style={{ cursor: "pointer" }}
          >
            {amt}
          </li>
        ))}
      </ul>
    </div>

    {/* Upload Proof */}
    <div className="my-3">
      <label className="form-label">Upload Proof:</label>
      <input type="file" className="form-control" accept="image/*" onChange={handleProofChange} />
      {proofPreview && (
        <div className="mt-3 text-center">
          <img src={proofPreview} alt="Proof Preview" className="img-thumbnail" style={{ maxHeight: "200px" }} />
        </div>
      )}
    </div>

    <button type="submit" className="btn btn-primary">
      Submit
    </button>
    </>
    )}
  </form>
);

// Hoist helper functions as well for consistency
const getBankDetails = (stake, bank) => {
  if (!bank) return {};

  if (stake > 1 && stake < 1000) {
    return {
      holder_name: bank?.holder_name,
      bank_name: bank?.bank_name,
      account_number: bank?.account_number,
      ifsc: bank?.ifsc_code,
    };
  } else if (stake >= 1000 && stake <= 2999) {
    return {
      holder_name: bank?.holder_name2,
      bank_name: bank?.bank_name2,
      account_number: bank?.account_number2,
      ifsc: bank?.ifsc_code2,
    };
  } else if (stake >= 3000 && stake <= 4999) {
    return {
      holder_name: bank?.holder_name3,
      bank_name: bank?.bank_name3,
      account_number: bank?.account_number3,
      ifsc: bank?.ifsc_code3,
    };
  } else if (stake >= 5000) {
    return {
      holder_name: bank?.holder_name4,
      bank_name: bank?.bank_name4,
      account_number: bank?.account_number4,
      ifsc: bank?.ifsc_code4,
    };
  }
  return {};
};

const getbankUpi = (stake, bank) => {
  if (!bank) return {};

  if (stake > 1 && stake < 1000) {
    return { upiId: bank?.stk };
  } else if (stake >= 1000 && stake <= 2999) {
    return { upiId: bank?.stk2 };
  } else if (stake >= 3000 && stake <= 4999) {
    return { upiId: bank?.stk3 };
  } else if (stake >= 5000) {
    return { upiId: bank?.stk4 };
  }
  return {};
};

const AdminRecharge = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [activeTab, setActiveTab] = useState("bank"); // default Bank
  const [stake, setStake] = useState(0);
  const [bank, setBank] = useState({});
  const [proof, setProof] = useState(null);
  const [proofPreview, setProofPreview] = useState(null);
  const [formData, setFormData] = useState({
    stake: 0,
    utr: '',
  });

  // Sidebar toggle
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Fetch bank details
  const details = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.get(base_url + "/api/webapi/getDetails", {
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      });

      if (response?.data?.success) {
        const data = response?.data?.bankk[0];
        setBank(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const contact= async()=>{
    try{
      const auth = localStorage.getItem('admin');
      const response = await axios.get(base_url + '/api/loggedContact',
        {
          headers:{
            Authorization: auth,
            'content-type':'application/json'
          }
        }
      );

      if(response?.data?.success){
        const data= response?.data?.number;
        setStake(data);        
      }

    }catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    details();
    contact();
  }, []);

  // File Upload + Preview
  const handleProofChange = (e) => {
    const file = e.target.files[0];
    setProof(file);
    if (file) {
      setProofPreview(URL.createObjectURL(file));
    }
  };

  // Resize listener for sidebar
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submit
  const handleSubmit = async(e, type) => {
    e.preventDefault();

    const bankDetails = type === "bank" ? getBankDetails(stake, bank) : {};
    const upiDetails = type === "upi" ? getbankUpi(stake, bank) : {};

    // Fix: Create a proper FormData object for submission
    const submitData = new FormData();
    submitData.append("stake", stake); // Use the number value
    submitData.append("utr", formData.utr);

    if(!formData.utr){
        toast.error("utr is required");
        return;
    }

    if (type === "bank") {
      submitData.append("holder_name", bankDetails.holder_name || "");
      submitData.append("bank_name", bankDetails.bank_name || "");
      submitData.append("account_number", bankDetails.account_number || "");
      submitData.append("ifsc", bankDetails.ifsc || "");
    }

    if (type === "upi") {
      submitData.append("upiId", upiDetails.upiId || "");
    }

    if (proof) {
      submitData.append("proof", proof);
    }else{
        toast.error("Proof is required");
        return;
    }

    // console.log('submitData', submitData);

    try{
        const auth = localStorage.getItem('admin');
        const response = await axios.post(
        `${base_url}/api/webapi/deposite`,
        submitData,
        {
          headers: {
            Authorization:auth,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

    //   console.log('resp',response);

      if (response?.data?.status) {
        toast.success(response?.data?.message);
        setFormData('');
        setProofPreview('');
        submitData('');
    } else {
        // console.log( response?.data?.message);
        toast.error(response?.data?.message);
    }

    }catch(err){
        console.log(err);
    }
  };

  return (
    <div className="wrapper bg-light min-vh-100">
      <AdminSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} isMobile={isMobile} />
      <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} isMobile={isMobile} />

      <div
        className={`content-wrapper overflow-auto d-flex flex-column align-items-center p-4 ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"}`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        <section className="w-100">
          <div className="mb-4">
            <h2 className="fw-bold">Recharge</h2>
          </div>

          {/* Tabs */}
          <div className="d-flex flex-wrap gap-3 mb-4">
            <button
              className={`btn ${activeTab === "bank" ? "btn-primary" : "btn-outline-primary"} d-flex align-items-center`}
              onClick={() => setActiveTab("bank")}
            >
              <i className="fa fa-university me-2"></i> Bank Payment
            </button>
            <button
              className={`btn ${activeTab === "qr" ? "btn-primary" : "btn-outline-primary"} d-flex align-items-center`}
              onClick={() => setActiveTab("qr")}
            >
              <i className="fa fa-qrcode me-2"></i> QR Code Payment
            </button>
            <button
              className={`btn ${activeTab === "upi" ? "btn-primary" : "btn-outline-primary"} d-flex align-items-center`}
              onClick={() => setActiveTab("upi")}
            >
              <i className="fa fa-mobile me-2"></i> UPI Payment
            </button>
            <button
              className={`btn ${activeTab === "contact" ? "btn-primary" : "btn-outline-primary"} d-flex align-items-center`}
              onClick={() => setActiveTab("contact")}
            >
              <i className="fa fa-phone-square me-2"></i> Contact
            </button>
          </div>

          {/* Dynamic Form */}
          <div className="d-flex justify-content-center">
            {activeTab === "bank" && (
              <RechargeForm
                type="bank"
                stake={stake}
                setStake={setStake}
                handleChange={handleChange}
                handleProofChange={handleProofChange}
                proofPreview={proofPreview}
                bank={bank}
                formData={formData}
                handleSubmit={handleSubmit} // Pass handleSubmit
              />
            )}
            {activeTab === "qr" && (
              <RechargeForm
                type="qr"
                stake={stake}
                setStake={setStake}
                handleChange={handleChange}
                handleProofChange={handleProofChange}
                proofPreview={proofPreview}
                bank={bank}
                formData={formData}
                handleSubmit={handleSubmit} // Pass handleSubmit
              />
            )}
            {activeTab === "upi" && (
              <RechargeForm
                type="upi"
                stake={stake}
                setStake={setStake}
                handleChange={handleChange}
                handleProofChange={handleProofChange}
                proofPreview={proofPreview}
                bank={bank}
                formData={formData}
                handleSubmit={handleSubmit} // Pass handleSubmit
              />
            )}

            {activeTab === "contact" && (
              <RechargeForm
                type="contact"
                stake={stake}
                setStake={setStake}
                handleChange={handleChange}
                handleProofChange={handleProofChange}
                proofPreview={proofPreview}
                bank={bank}
                formData={formData}
                handleSubmit={handleSubmit} // Pass handleSubmit
              />
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default AdminRecharge;